import { PageHero } from "../components/PageHero";
import { Reveal, Eyebrow } from "../components/Reveal";
import { CtaBand } from "../components/CtaBand";
import { UseCaseCard } from "../components/UseCaseCard";
import { USE_CASES } from "../data/content";

export default function Missions() {
  return (
    <div data-testid="missions-page">
      <PageHero eyebrow="Missions" color="#45ADE0" title="Les missions que vous pouvez confier à ENOVA." />
      <section className="mx-auto max-w-7xl px-5 lg:px-8 py-16 lg:py-24" data-testid="missions-list">
        <Eyebrow color="#45ADE0">Types de missions</Eyebrow>
        <div className="mt-10 grid md:grid-cols-2 lg:grid-cols-6 gap-4">
          {USE_CASES.map((u, i) => (
            <Reveal key={u.id} delay={i * 0.05} className={i < 2 ? "lg:col-span-3" : "lg:col-span-2"}><UseCaseCard u={u} large={i < 2} /></Reveal>
          ))}
        </div>
      </section>
      <CtaBand />
    </div>
  );
}
